export { NumberDecimalColumnComponent } from './number-decimal-column.component';
